import { Flex, Loading, NotFound } from '@/components';
import { useId } from '@/hooks';
import type { FC } from 'react';
import { useBatch } from '../../_hooks/batch';
import { BatchErrorDetails } from './BatchErrorDetails';
import { BatchPaymentGroupUploadContent } from './BatchPaymentGroupUploadContent';
import { BatchResult } from './BatchResult';
import { DownloadBatchFile } from './download-batch-file/DownloadBatchFile';

export const BatchContent: FC = () => {
  const { id } = useId();
  const { data: batch, isPending, isError } = useBatch(id);

  if (isError) {
    return <NotFound backRoute="/batch" />;
  }
  if (isPending || !batch) {
    return <Loading />;
  }

  const errorDetails = batch.taskResult.result?.errorDetails ?? [];

  return (
    <Flex vertical gap={16} align="center">
      <Flex vertical gap={16}>
        <BatchResult batch={batch} />
        {batch.hasDownloadFile && <DownloadBatchFile batch={batch} />}
      </Flex>
      {errorDetails.length > 0 && (
        <BatchErrorDetails errorDetails={errorDetails} />
      )}
      {/* 支出先グループアップロードと国庫債務負担行為等による契約先アップロードのみ表示 */}
      {(batch.target === 'payment-group-upload' ||
        batch.target === 'contractor-payment-upload') && (
        <BatchPaymentGroupUploadContent batchParams={batch.params} />
      )}
    </Flex>
  );
};
